/**
 * Jules Tools menu. The dropdown itself -- the tool list, per-person favourites and the
 * data-lineage viewer -- is rendered by nav.js from the hub (the script tag is in
 * index.html) into a shadow root on this mount. The link inside is the fallback: the
 * shadow root hides it once that script has run, so it shows only if nav.js never
 * loads, and the header is never without its way out.
 *
 * Every link in the menu opens in a new tab: a same-tab navigation can unload the page
 * mid-request, and here that would throw away a lookup that took several seconds of
 * SEC round trips.
 */
export default function ToolsNav() {
  return (
    <div
      data-jules-nav
      style={{
        '--jn-fg': 'var(--ink-soft)',
        '--jn-fg-hover': 'var(--ink)',
        '--jn-border': 'var(--line-strong)',
        '--jn-radius': 'var(--radius-sm)',
        '--jn-panel-border': 'var(--line)',
      }}
    >
      <a href="https://cvp.julianfife.com" target="_blank" rel="noopener noreferrer" className="btn-quiet">
        Jules Tools
      </a>
    </div>
  );
}
